import Loadable from '../../components/loadable';

const BulkSequenceEnrolment = Loadable({
  loader: () => import('../../pages/sequences/bulk_sequence_enrolment/bulk_sequence_enrolment'),
});

angular.module('gym').value('BulkSequenceEnrolment', BulkSequenceEnrolment);

const BulkSequenceEnrolmentFiltersModal = Loadable({
  loader: () =>
    import('../../pages/sequences/bulk_sequence_enrolment/bulk_sequence_enrolment_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('BulkSequenceEnrolmentFiltersModal', BulkSequenceEnrolmentFiltersModal);

const ConfirmBulkSequenceEnrolmentModal = Loadable({
  loader: () =>
    import('../../pages/sequences/bulk_sequence_enrolment/confirm_bulk_sequence_enrolment_modal'),
  type: 'modal',
});

angular.module('gym').value('ConfirmBulkSequenceEnrolmentModal', ConfirmBulkSequenceEnrolmentModal);
